import axios from 'axios'

export const state = () => ({
  currentVersion: null,
  availableVersion: null,
  lastUpdate: null,
})

export const getters = {
  updated: state => state.currentVersion === state.availableVersion,
}

export const mutations = {
  setCurrent: (state, version) =>
    Object.assign(state, { currentVersion: version }),
  setAvailable: (state, version) =>
    Object.assign(state, { availableVersion: version }),
  setUpdate: state =>
    Object.assign(state, { lastUpdate: new Date().toISOString() }),
}

export const actions = {
  async fetch({ commit }) {
    commit('setCurrent', window.$versionTag)
    if (!navigator.onLine) return
    try {
      const response = await axios.get('/_version', {
        baseURL: window.location.origin,
      })
      commit('setAvailable', response.data.toString().replace(/(\r|\n)/g, ''))
    } catch (e) {
      console.error(e)
      $nuxt.$rollbar.error(e)
    }
  },
}
